
export default async function initBadge(win) {
    const products = win.document.querySelectorAll(`.product-tile`);
    const marketing_enrichment_product_badge_api = `/search/marketing-enrichment-api/product-badge`;

    const productsByCode = new Map();
    [...products].forEach((product) => {
        const code = product.dataset.productCode;
        if (!code) return;
        if (!productsByCode.has(code)) {
            productsByCode.set(code, []);
        }
        productsByCode.get(code).push(product);
    });

    const uniqueProductCodes = [...productsByCode.keys()];

    // Collect unique product codes as a comma-separated string
    const productCodes = uniqueProductCodes.join(",");

    let searchParams = new URLSearchParams();
    searchParams.append("productCodes", productCodes);
    const queryString = `?${searchParams.toString()}`;
    let badgeData = [];
    try {
        const badgeResp = await fetch(`${marketing_enrichment_product_badge_api}${queryString}`, {
            headers: { accept: "*/*" }
        });
        const badgeJson = await badgeResp.json();
        badgeData = badgeJson.content || [];
    } catch (e) {
        console.error("Failed to fetch badge data", e);
        badgeData = [];
    }

    // Map productCode to badge object for quick lookup
    const badgeMap = {};
    badgeData.forEach(badge => {
        if (badge.productCode !== undefined && badge.productCode !== null && Array.isArray(badge.badgeWidget) && badge.badgeWidget.length > 0) {
            badgeMap[String(badge.productCode)] = badge;
        }
    });

    console.log("Badge data fetched to display badge ", badgeMap);

    // For each unique product code, render badges into all tile variants
    uniqueProductCodes.forEach((code) => {
        const badge = badgeMap[code];
        if (!(badge && Array.isArray(badge.badgeWidget))) return;

        const productTiles = productsByCode.get(code) || [];
        productTiles.forEach((product) => {
            // Use a fragment to batch badge DOM nodes
            const fragment = document.createDocumentFragment();
            badge.badgeWidget.forEach(widget => {
                if (!widget.badgeTitle) return;

                const badgeEl = document.createElement("div");
                badgeEl.classList.add("badge-container");

                // Prepare CSS variable values
                const badgeTextColor = widget.badgeTextColor;
                const badgeHoverTextColor = widget.badgeHoverTextColor;
                const badgeFocusTextColor = widget.badgeFocusTextColor;
                const badgeBackgroundColor = widget.badgeBackgroundColor;
                const badgeHoverBackgroundColor = widget.badgeHoverBackgroundColor;
                const badgeFocusBackgroundColor = widget.badgeFocusBackgroundColor;
                const badgeBorderColor = widget.badgeBorderColor;
                const badgeHoverBorderColor = widget.badgeHoverBorderColor;
                const badgeFocusBorderColor = widget.badgeFocusBorderColor;

                // Create rg-badge element
                const rgBadge = document.createElement("rg-badge");
                rgBadge.setAttribute("priority", widget.badgeThemeSelection || "default");
                rgBadge.setAttribute("class", "hydrated");
                rgBadge.setAttribute("style",
                    `--badge-text-color:${badgeTextColor};` +
                    `--badge-hover-text-color:${badgeHoverTextColor};` +
                    `--badge-focus-text-color:${badgeFocusTextColor};` +
                    `--badge-background-color:${badgeBackgroundColor};` +
                    `--badge-hover-background-color:${badgeHoverBackgroundColor};` +
                    `--badge-focus-background-color:${badgeFocusBackgroundColor};` +
                    `--badge-border-color:${badgeBorderColor};` +
                    `--badge-hover-border-color:${badgeHoverBorderColor};` +
                    `--badge-focus-border-color:${badgeFocusBorderColor};`
                );

                // Build badge content
                const iconHtml = widget.badgeIcon
                    ? `<rg-icon icon="${widget.badgeIcon}" margin="right" ratio="1" class="hydrated"></rg-icon>`
                    : '';
                const content = `${iconHtml}${widget.badgeTitle}`;
                const inner = widget.badgeLinkUrl
                    ? `<a href="${widget.badgeLinkUrl}" target="_blank" title="${widget.badgeLinkDescription || ''}" aria-label="${widget.badgeLinkText || widget.badgeTitle}" style="text-decoration:none;color:inherit;">${content}</a>`
                    : content;

                // Set inner HTML
                const span = document.createElement("span");
                span.innerHTML = inner;
                rgBadge.appendChild(span);

                // Add hover event listeners
                rgBadge.addEventListener('mouseenter', function () {
                    rgBadge.style.setProperty('--badge-background-color', badgeHoverBackgroundColor);
                });
                rgBadge.addEventListener('mouseleave', function () {
                    rgBadge.style.setProperty('--badge-background-color', badgeBackgroundColor);
                });

                badgeEl.appendChild(rgBadge);
                fragment.appendChild(badgeEl);
            });

            let containerEls = product.querySelectorAll(".pill-container");
            if (containerEls && containerEls[0]) {
                containerEls[0].insertBefore(fragment, containerEls[0].firstChild);
            }
        });
    });

    // Custom order badge should be rendered for all tile variants of a product code
    try {
        uniqueProductCodes.forEach((code) => {
            const productTiles = productsByCode.get(code) || [];
            const hasCustomOrder = productTiles.some((product) => String(product.dataset.customOrder).toLowerCase() === "true");
            if (!hasCustomOrder) return;

            productTiles.forEach((product) => {
                let badgeEl = document.createElement("div");
                badgeEl.classList.add("badge-container");
                badgeEl.innerHTML =
                    `<rg-badge priority="default" style="--badge-background-color: #94BAF6;--badge-border-color: #94BAF6;--badge-hover-background-color: #94BAF6;--badge-focus-background-color: #94BAF6;" class="hydrated">
                        <span><rg-icon icon="zmdi zmdi-time-countdown" margin="right" ratio="1" theme="" class="hydrated"></rg-icon>Made to Order</span>
                    </rg-badge>`;
                let containerEls = product.querySelectorAll(
                    ".pill-container"
                );
                if (!containerEls || containerEls.length === 0) return;
                containerEls[0].insertBefore(badgeEl, containerEls[0].firstChild);
            });
        });
    } catch (err) {
        throw new Error(err);
    }
}
